module.exports = __webpack_public_path__ + "assets/img/all_award_item.b9b651b5.png";